import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserDataRequestService {
  private isRefisPeriodActive: Subject<boolean> = new Subject<boolean>();
  private isRepresentingAnotherPerson: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private representativeData = new BehaviorSubject<any>(null);
  private requerenteSubject = new BehaviorSubject<any>(null);
  constructor() { }

  addValueRefisPeriodActive(isActive: boolean): void {
    this.isRefisPeriodActive.next(isActive);
  }

  getRefisPeriodStatus(): Observable<boolean> {
    return this.isRefisPeriodActive.asObservable();
  }

  setRepresentativeData(data: any): void {
    this.representativeData.next(data);
  }

  getRepresentativeData(): Observable<any> {
    return this.representativeData.asObservable();
  }

  setRequerente(data: any) {
    this.requerenteSubject.next(data);
  }

  getRequerente(): Observable<any> {
    return this.requerenteSubject.asObservable();
  }

  setRepresentingAnotherPerson(value: boolean): void {
    this.isRepresentingAnotherPerson.next(value);
  }

  getRepresentingAnotherPerson(): Observable<boolean> {
    return this.isRepresentingAnotherPerson.asObservable();
  }
}